import { serverOnly$ } from "vite-env-only/macros";
import enTranslations from "../locales/en/common.json";
import frTranslations from "../locales/fr/common.json";
import enStudioTranslations from "../locales/en/studio.json";
import frStudioTranslations from "../locales/fr/studio.json";

export const supportedLngs = ["en", "fr"];
export const fallbackLng = "en";
export const defaultNS = "common";
export const ns = ["common", "studio"];

export const resources = serverOnly$({
  en: {
    common: enTranslations,
    studio: enStudioTranslations,
  },
  fr: {
    common: frTranslations,
    studio: frStudioTranslations,
  },
});
